<template>
  <v-container class="pt-0" style="height: 100%; background-color: #f3f3f3">
    <v-row>
      <v-col class="mx-0 px-0 pt-0">
        <header-text-bg
          :site="site"
          text="registerMemberPage"
          redirect_name="my-member"
        />
      </v-col>
    </v-row>

    <v-container fluid class="pa-0">
      <Survey v-if="survey" :survey="survey" />
    </v-container>
  </v-container>
</template>

<script>
import Axios from "@/config/customer-service";
import { mapState } from "vuex";
import HeaderTextBg from "../../../components/headerTextBg.vue";
import { Survey } from "survey-vue-ui";
import { Model } from "survey-vue";
import "survey-core/defaultV2.min.css";
import { themeJson } from "../../../scss/themeJson.js";
import {
  addClassQlEditorToSDDisplay,
  addDivCustomInputMaskPattern,
  formattedForSave,
  transformJsonCustomInputMask,
} from "../../../config/general-function.js";
import { provinces } from "../../../config/location/provinces.js";
import { districts } from "../../../config/location/districts.js";
import { sub_districts } from "../../../config/location/sub_districts.js";

const customCss = {
  question: {
    content: "question-content",
    titleRequired: "question-title-required",
  },
};

export default {
  inject: ["isAppLoading"],
  components: {
    HeaderTextBg,
    Survey,
  },
  data: () => ({
    survey: null,
    registerForm: {},
    campaign: {},
  }),
  async mounted() {
    const account_type = this.site?.account_type || "individual";
    const my_member_count = this.customer?.my_member_count || 1;
    const limit_member = this.site?.account_type_detail?.limit_member || 1;
    if (
      ["multi_profile", "group_account"].includes(account_type) &&
      my_member_count < limit_member
    ) {
      await this.getRegisterFormMember();
      this.onInit();
      this.disabledField(account_type);
    }
  },
  methods: {
    async getRegisterFormMember() {
      this.isAppLoading(true);
      try {
        const response = await Axios.get("getRegisterFormMember");
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          const data = dataResponse.data;
          this.campaign = { ...data };
          if (data.schema) {
            this.registerForm = { ...data.schema };
          }
        }
      } catch (err) {
        console.log("getRegisterFormMember", err);
      }
      this.isAppLoading(false);
    },
    async onInit() {
      if (!this.registerForm.completeText) {
        this.registerForm.completeText = this.$t("register");
      }
      this.registerForm.showCompletedPage = false;
      this.registerForm.checkErrorsMode = "onValueChanged";
      this.registerForm = this.setQuestionAddress(this.registerForm);
      this.registerForm = transformJsonCustomInputMask(this.registerForm);
      this.survey = new Model(this.registerForm);

      if (this.survey) {
        this.survey.onComplete.add((sender, options) => {
          this.submitForm(sender, options);
        });
        let _themeJson = { ...themeJson };
        if (this.campaign?.theme) {
          _themeJson = { ...this.campaign.theme };
          if (!_themeJson.backgroundImage) {
            _themeJson.backgroundImage = "";
          }
        } else {
          this.survey.css = customCss;
          _themeJson.cssVariables["--sjs-primary-backcolor"] = this.site.color;
          _themeJson.cssVariables["--sjs-primary-backcolor-dark"] =
            this.site.color;
        }

        this.survey.applyTheme(_themeJson);
        this.onValueChanged();
        this.onAfterRenderPage();
        this.onAfterRenderQuestion();
        this.uploadImage();
      }
      // ========== ========== ========== ==========
    },
    disabledField(param) {
      // phone
      if (
        this.survey.getQuestionByName("question3") &&
        param == "multi_profile"
      ) {
        this.survey.getQuestionByName("question3").readOnly = true;
        this.survey.setValue("question3", this.customer.phone);
      }

      // email
      // if (this.survey.getQuestionByName("email") && param == "multi_profile") {
      //   this.survey.getQuestionByName("email").readOnly = true;
      //   this.survey.setValue("email", this.customer.email);
      // }
    },
    onValueChanged() {
      const _isAppLoading = (param) => {
        this.isAppLoading(param);
      };
      this.survey.onValueChanged.add((sender, options) => {
        const name = options.name;
        const value = options.value;
        const questions = this.survey.getAllQuestions();
        // ========== ========== Set Null Value Invisible Question ========== ==========
        const invisible_questions = questions.filter((x) => !x.visible);
        for (let invisible_question of invisible_questions) {
          const _name = invisible_question.name;
          const model = this.survey.getQuestionByName(_name);
          if (model) {
            this.survey.setValue(_name, null);
          }
        }
        // ========== ========== Address ========== ==========
        if (name == "province") {
          const district = this.survey.getQuestionByName("district");
          if (district) {
            let list = [];
            let readOnly = true;
            if (value) {
              readOnly = false;
              list = districts
                .filter((x) => x.province_id == value)
                .map((x) => {
                  return {
                    value: x.id,
                    text: x.name_th,
                  };
                });
            }
            district.readOnly = readOnly;
            district.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = district.page;
            page.removeElement(district);
            setTimeout(() => {
              const _province = this.survey.getQuestionByName("province");
              const _page = _province.page;
              const originalIndex = _page.elements.indexOf(_province);
              this.survey.setValue("district", null);
              _page.addElement(district, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        if (name == "district") {
          const sub_district = this.survey.getQuestionByName("sub_district");
          if (sub_district) {
            let list = [];
            let readOnly = true;
            if (value) {
              readOnly = false;
              list = sub_districts
                .filter((x) => x.district_id == value)
                .map((x) => {
                  return {
                    value: x.id,
                    text: x.name_th,
                  };
                });
            }
            sub_district.readOnly = readOnly;
            sub_district.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = sub_district.page;
            page.removeElement(sub_district);
            setTimeout(() => {
              const _district = this.survey.getQuestionByName("district");
              const _page = _district.page;
              const originalIndex = _page.elements.indexOf(_district);
              this.survey.setValue("sub_district", null);
              _page.addElement(sub_district, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        if (name == "sub_district") {
          const zip_code = this.survey.getQuestionByName("zip_code");
          if (zip_code) {
            let list = [];
            let readOnly = true;
            let _value = null;
            if (value) {
              readOnly = false;
              const model = sub_districts.find((x) => x.id == value);
              const zip_codes = model?.zip_codes || [];
              if (zip_codes.length > 0) {
                _value = `${model.id}_${zip_codes[0]}`;
              }
              for (let item of zip_codes) {
                list.push({
                  value: `${model.id}_${item}`,
                  text: `${item}`,
                });
              }
            }
            zip_code.readOnly = readOnly;
            zip_code.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = zip_code.page;
            page.removeElement(zip_code);
            setTimeout(() => {
              const _sub_district =
                this.survey.getQuestionByName("sub_district");
              const _page = _sub_district.page;
              const originalIndex = _page.elements.indexOf(_sub_district);
              this.survey.setValue("zip_code", _value);
              _page.addElement(zip_code, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        // ========== ========== ========== ==========
      });
    },
    onAfterRenderPage() {
      this.survey.onAfterRenderPage.add(function (sender, options) {
        console.log(options);
        addClassQlEditorToSDDisplay();
      });
    },
    onAfterRenderQuestion() {
      this.survey.onAfterRenderQuestion.add((sender, options) => {
        const jsonObj = options.question.jsonObj;
        const prefix = jsonObj._customPrefix;
        const questionEl = options.htmlElement;
        if (prefix) {
          addDivCustomInputMaskPattern(questionEl, prefix);
        }
        addClassQlEditorToSDDisplay();
      });
    },
    setQuestionAddress(schema) {
      let pages = schema?.pages || [];
      const setAddress = (elements) => {
        if (Array.isArray(elements)) {
          const province = elements.find((x) => x.name == "province");
          if (province) {
            province.choices = provinces.map((x) => {
              return {
                value: x.id,
                text: x.name_th,
              };
            });
          }
          // ========== ========== ========== ==========
          const district = elements.find((x) => x.name == "district");
          if (district) {
            district.readOnly = true;
          }
          // ========== ========== ========== ==========
          const sub_district = elements.find((x) => x.name == "sub_district");
          if (sub_district) {
            sub_district.readOnly = true;
          }
          // ========== ========== ========== ==========
          const zip_code = elements.find((x) => x.name == "zip_code");
          if (zip_code) {
            zip_code.readOnly = true;
          }
        }
        return elements;
      };
      if (Array.isArray(pages) && pages.length > 0) {
        for (let item of pages) {
          let elements = item?.elements || [];
          elements = setAddress(elements);
          if (item) {
            item.elements = elements;
          }
        }
        if (schema) {
          schema.pages = pages;
        }
      } else {
        let elements = schema?.elements || [];
        elements = setAddress(elements);
        if (schema) {
          schema.elements = elements;
        }
      }
      return schema;
    },
    async submitForm(sender, options) {
      options.showSaveInProgress();
      let has_heic = false;
      let question_name_has_heic = null;
      if (typeof sender.data == "object") {
        for (let key of Object.keys(sender.data)) {
          let question = sender.data[key];
          if (Array.isArray(question) && question.length > 0) {
            if (
              this.isImage(question[0].name) ||
              this.isVideo(question[0].name) ||
              this.isPDF(question[0].name) ||
              this.isSpreadsheet(question[0].name)
            ) {
              const imageFile = await this.convertBase64ToFile(
                question[0].content,
                question[0].name
              );
              const imageUrl = await this.uploadImageDefault(imageFile);
              question[0].content = imageUrl;
            } else if (this.isHeic(question[0].name)) {
              has_heic = true;
              question = null;
              question_name_has_heic = key;
            }
          }
        }
      }
      if (has_heic) {
        options.showSaveError();
        sender.clear(false);
        if (question_name_has_heic) {
          const targetQuestion = sender.getQuestionByName(
            question_name_has_heic
          );
          if (targetQuestion) {
            targetQuestion.addError(this.$t("error.heicNotSupported"));
            targetQuestion.focus();
          }
        }
        return;
      }
      this.register(sender);
    },
    isImage(link) {
      return /\.(gif|jpe?g|jfif|tiff?|png|webp|bmp|avif|svg)$/i.test(link);
    },
    isVideo(link) {
      return /\.(mp4|webm|ogg|avi|mov)$/i.test(link);
    },
    isPDF(link) {
      return /\.pdf$/i.test(link);
    },
    isSpreadsheet(link) {
      return /\.(xls|xlsx|csv)$/i.test(link);
    },
    isHeic(link, mimeType = "") {
      const isExtensionHeic = /\.(heic|heif)$/i.test(link);
      const isMimeHeic = ["image/heic", "image/heif"].includes(
        mimeType.toLowerCase()
      );
      return isExtensionHeic || isMimeHeic;
    },
    convertBase64ToFile(base64, nameImage) {
      return new Promise((resolve) => {
        const fetchBase64 = fetch(base64);
        fetchBase64
          .then((r) => r.blob())
          .then((blobFile) => {
            const image = new File([blobFile], nameImage, {
              type: blobFile.type,
            });
            resolve(image);
          })
          .catch((err) => {
            console.log("convertBase64ToFile", err);
            resolve(null);
          });
      });
    },
    uploadImageDefault(file) {
      return new Promise((resolve) => {
        const formData = new FormData();
        formData.append("image", file);
        Axios.post("/uploadImageRegister", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then(({ data }) => {
            if (data.status == "success") {
              resolve(data.image_url);
            }
          })
          .catch(() => {
            resolve(null);
          });
      });
    },
    uploadImage() {
      this.survey.onUploadFiles.add(function (_, options) {
        options.files.forEach(function (file) {
          const formData = new FormData();
          formData.append("image", file);
          Axios.post("/uploadImageRegister", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
            .then(({ data }) => {
              if (data.status == "success") {
                options.callback("success", [
                  {
                    file: file,
                    content: data.image_url,
                  },
                ]);
              }
            })
            .catch((err) => {
              throw err;
            });
        });
      });
    },

    async register(sender) {
      this.isAppLoading(true);
      // ========== ========== ========== ==========
      const formatJson = formattedForSave(this.survey.jsonObj, sender.data);
      // ========== ========== ========== ==========
      const body = {
        parent_employee_id: this.customer.id,
        campaign_id: this.campaign?.id,
        name: sender.data.question1,
        surname: sender.data.question2,
        phone: sender.data.question3,
        birth_date: sender.data.birth_date || null,
        gender: sender.data.gender || null,
        code: sender.data.code || null,
        platform: this.site.platform,
        invite: null,
        detail: JSON.stringify(formatJson),
        mission_id: null,
        line_id: null,
        profile_path: null,
        email: sender.data.email || null,
      };
      Axios.post(`/registerUser`, body)
        .then((res) => {
          if (res?.data?.status === "success") {
            this.$swal
              .fire({
                icon: "success",
                title: this.$t("statusRegistrationSuccess"),
                showConfirmButton: false,
                timer: 3000,
              })
              .then(() => {
                this.isAppLoading(false);
                this.$router.push({ name: "my-member" });
              });
          } else if (res?.data?.status === "pending") {
            this.$swal
              .fire({
                icon: "warning",
                text: res?.data?.message,
                showConfirmButton: false,
                timer: 2000,
              })
              .then(() => {
                this.isAppLoading(false);
                this.$router.push({ name: "my-member" });
              });
          } else {
            this.$swal
              .fire({
                icon: "error",
                text: this.$t("statusRegistrationFailed"),
                showConfirmButton: false,
                timer: 2000,
              })
              .then(() => {
                this.isAppLoading(false);
                location.reload();
              });
          }
        })
        .catch((err) => {
          console.log("LoginWithOtpOption:RegisterPhone:register[err]", err);
          this.$swal
            .fire({
              icon: "error",
              title:
                err?.response?.data?.message ||
                this.$t("statusRegistrationFailed"),
              showConfirmButton: false,
              timer: 2000,
            })
            .then(() => {
              this.isAppLoading(false);
              location.reload();
            });
        });
      this.survey.doComplete();
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
  },
  filters: {},
};
</script>

<style scoped>
</style>
